module.exports = __webpack_public_path__ + "img/sketch-wallet-mobile.ef702cad.svg";